// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1V5KE","boxTitle":"Qualiphy_boxTitle__2AlD8","box":"Qualiphy_box__1VDiV","toggleWrap":"Qualiphy_toggleWrap__ilTQb"};